import { Portal } from '@chakra-ui/react';

import { CloseButton } from '../CloseButton';
import { DialogOrDrawer } from '../DialogOrDrawer';
import { InDesktop } from '../MobileOrDesktop';
import { DefaultContent } from './components/DefaultContent';
import { useTokenSelectDialog } from './useTokenSelectDialog';

export const TokenSelectDialog = () => {
  const isOpen = useTokenSelectDialog((s) => s.isOpen);
  const close = useTokenSelectDialog((s) => s.close);

  return (
    <DialogOrDrawer.Root
      size="md"
      scrollBehavior="inside"
      placement={{
        desktopDown: 'bottom',
        desktop: 'top',
      }}
      open={isOpen}
      onOpenChange={(state) => !state.open && close()}
    >
      <Portal>
        <DialogOrDrawer.Backdrop />
        <DialogOrDrawer.Positioner>
          <DialogOrDrawer.DragContent
            h={{
              desktopDown: '60vh',
              desktop: 'min(500px, 80vh)',
            }}
          >
            <InDesktop>
              <DialogOrDrawer.CloseTrigger asChild>
                <CloseButton />
              </DialogOrDrawer.CloseTrigger>
            </InDesktop>
            <DefaultContent />
          </DialogOrDrawer.DragContent>
        </DialogOrDrawer.Positioner>
      </Portal>
    </DialogOrDrawer.Root>
  );
};
